export enum AccessLevels {
  Open = "open",
  Private = "private",
  Paid = "paid",
  Plan = "plan"
}

export enum PostingPermissions {
  Admin = "admin",
  Members = "members"
}

export enum EventRegistrationTypes {
  Internal = "internal",
  External = "external",
}
